/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

export interface CardListHeadingStyles {
    headingWrapper?: InjectableCss;
    headingContainer?: InjectableCss;
    headingTitle?: TypographyProps;
    viewAllLink?: InjectableCss;
}

export const cardListHeadingStyles: CardListHeadingStyles = {};

const styles = cardListHeadingStyles;

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <GridItem {...styles.headingWrapper} width={12}>
            <GridContainer {...styles.headingContainer}>
                <GridItem width={6}>
                    <Typography className="card-list-heading" {...styles.headingTitle} variant="h5">
                        {heading}
                    </Typography>
                </GridItem>
                {viewAllUrl && (
                    <GridItem {...styles.viewAllLink} width={6}>
                        <Link
                            className="view-all-link"
                            href={viewAllUrl}
                            icon={{ iconProps: { src: ChevronRight } }}
                            typographyProps={{ size: 15 }}
                            data-test-selector="cardListHeadingViewAllLink"
                        >
                            {translate("View All")}
                        </Link>
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

export default CardListHeading;
